import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as projectActions from "../../../../actions/project.actions";
import * as adminActions from "../../../../actions/admin.actions";

import Projects from "../components/Projects";

import parseAdvancedSearch from "../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../utils/parseFilters";
import {
  decodeSearchParams,
  getFinalQueryString
} from "../../../../utils/parseQueries";

class ProjectsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: [],
      filters: []
    };
  }

  componentWillMount() {
    this.setState({ ...decodeSearchParams(this.props.location.search) });
  }

  componentDidMount() {
    const filters = getFinalQueryString(
      parseFilters(this.state.filters) +
        parseAdvancedSearch(this.state.advancedSearch)
    );

    this.props.projectActions.getAdminProjects(filters);
    this.props.projectActions.getAdminProjectsCSVData(filters);
  }

  render() {
    return (
      <Projects
        advancedSearch={this.state.advancedSearch}
        filters={this.state.filters}
        getCsvData={this.props.projectActions.getAdminProjectsCSVData}
        getTable={this.props.projectActions.getAdminProjects}
        history={this.props.history}
        loading={this.props.loading}
        numberOfPages={this.props.projects.last_page}
        page={this.props.page}
        paginationCount={this.props.paginationCount}
        projects={this.props.projects.data || []}
        projects_csv={_.get(this.props, "projects_csv.data") || []}
        setPage={this.props.adminActions.setPage}
        setSort={this.props.adminActions.setSort}
        sortData={this.props.sortData}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.project.loadingGetProjects,
    page: state.admin.pagination.projects,
    paginationCount: adminActions.getPaginationCounts(state.admin.pagination),
    projects: state.project.projects,
    projects_csv: state.project.projects_csv,
    sortData: state.admin.sorting.projects
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectsContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/projects/containers/ProjectsContainer.js